import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-upgrade-plan-v2',
  templateUrl: './upgrade-plan-v2.component.html',
  styleUrls: ['./upgrade-plan-v2.component.scss']
})
export class UpgradePlanV2Component implements OnInit {

    visuel = '';
    plan = '';
    feature = '';
    loading = false;
    disableClose = false;

    constructor(
        public dialogRef: MatDialogRef<UpgradePlanV2Component>,
        private trackingService: TrackingService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit() {
        this.visuel = this.data.visuel;
        this.plan = this.data.plan;
        this.feature = this.data.feature;
        this.disableClose = this.data.disableClose;
        if (this.disableClose == undefined) {
            this.disableClose = false;
        }
    }

    onNoClick(): void {
        if (this.disableClose == true) {
            return;
        }
        this.trackingService.click('upgrade_plan_cancel', this.feature);
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.loading = true;
        this.trackingService.click('upgrade_plan_valid', this.feature);
        this.router.navigate(['/app/user/plan']);
        this.dialogRef.close(true);
    }
}
